import clsx from "clsx";
import { KTSVG } from "src/_metronic/helpers";

const toolbarButtonMarginClass = "ms-1 ms-lg-3";
const toolbarButtonHeightClass = "w-30px h-30px w-md-40px h-md-40px";
const toolbarButtonIconSizeClass = "svg-icon-1";

const ActivitiesMenu = () => {
    return (
        <div className={clsx("d-flex align-items-center", toolbarButtonMarginClass)}>
            <div
                className={clsx(
                    "btn btn-icon btn-active-light-primary btn-custom",
                    toolbarButtonHeightClass
                )}
                id="kt_activities_toggle"
            >
                <KTSVG
                    path="/media/icons/duotune/text/txt009.svg"
                    className={toolbarButtonIconSizeClass}
                />
            </div>
        </div>
    );
};

export default ActivitiesMenu;
